import React from 'react';

import LogoImg from 'images/new_ui/logo.svg';

export default function Index() {
  return (
    <div className="text-center">
      <div className="mt-5">
        <img src={LogoImg} alt="LeggUP" height="30px" />
      </div>
      <div className="mt-5 mb-5">
        <p className="fs-2">Please close this page to return to the LeggUP app.</p>
        <p className="fs-2 mt-2"> Thank you!</p>
      </div>
    </div>
  );
}
